<template>
  <div>
    <div v-if="totalNodeDelegators > 0">
      <!-- <v-toolbar
        flat
        dense
      >
        <p style="color: black">Total Stakes: {{ nodeDelegatorsStakeSum }}</p>
      </v-toolbar> -->
      <b-table
        :data="nodeDelegators"
        class="table"
	    v-bind:mobileCards="false"
      >
        <template slot-scope="props">
          <b-table-column field="rank" label="Rank">
            {{ props.index + (current_page * pageSize + 1) - pageSize }}
          </b-table-column>

          <b-table-column field="address" label="Address">
            <router-link
              class="router-link short-addr"
              :to="{ name: 'address', params: {address: props.row.address}}"
            >
              {{ props.row.address }}
            </router-link>
          </b-table-column>

          <b-table-column field="comp_rate" label="Compensation">
            {{ props.row.comp_rate | convertFraction() }}
          </b-table-column>

          <b-table-column field="delegate_amount" label="Delegated Amount">
            {{ props.row.stake_amount || '--' }} CMT
          </b-table-column>
        </template>
      </b-table>
    </div>
      <Empty v-else/>
      <el-pagination
        small
        background
        @current-page="current_page"
        @current-change="shiftPage"
        @prev-click="shiftPage(current_page-1)"
        @next-click="shiftPage(current_page+1)"
        layout="prev, pager, next"
        :current_page.sync="current_page"
        :pager-count=5
        :page-size="pageSize"
        :total="totalNodeDelegators">
      </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Empty from '../reusables/empty.vue';

export default {
  name: 'NodeDelegators',
  components: {
    Empty,
  },
  computed: {
    ...mapGetters([
      'nodeDelegators',
      'totalNodeDelegators',
      'nodeDelegatorsStakeSum',
    ]),
  },
  filters: {
    convertFraction(value) {
      const split = value.split('/');
      const decimal = parseInt(split[0], 10) / parseInt(split[1], 10);
      const percentage = decimal * 100;
      return value.indexOf('/') > -1 ? `${percentage.toFixed(2)}%` : value;
    },
  },
  data() {
    return {
      current_page: 1,
      pageSize: 10,
    };
  },
  methods: {
    shiftPage(page) {
      this.$store.dispatch('fetchNodeDelegators', {
        address: this.$route.params.address,
        limit: this.pageSize,
        page,
      });
      this.current_page = page;
    },
  },
  created() {
    this.shiftPage(1);
  },
};
</script>
